export default __webpack_public_path__ + "static/media/lungs.a4da808d.png";